import * as _ from "lodash";
import * as actions from "../../../store/actions";

import React, {Component} from "react";
import {canCreate, canDelete, filterResults, handleSearchResults} from "../../../services/Api";

import AddClusterPopup from "../Popup/AddClusterPopup";
import CustomSearch from "../../UI-components/CustomSearch";
import CustomSelect from "../../UI-components/CustomSelect";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import ListItem from "./ListItem";
import ListItemHome from "./ListItemHome";
import {connect} from "react-redux";
import Button from "../../UI-components/Button";
import Popup from "../../UI-components/Popup";
import {OPENED_CLUSTER_LIMIT} from "../../../config";

const sortMonthIds = (monthA, monthB) => {
  if (!monthA || !monthB) return 0;
  const [m1, y1] = monthA.split("_");
  const [m2, y2] = monthB.split("_");
  if (y1 !== y2) {
    return parseInt(y1, 10) - parseInt(y2, 10);
  }
  const monthNum1 = m1 ? parseInt(m1.substring(1), 10) : 0;
  const monthNum2 = m2 ? parseInt(m2.substring(1), 10) : 0;
  return monthNum1 - monthNum2;
};

class ListCluster extends Component {
  state = {
    isAddClusterOpen: false,
    selectedClusters: [],
    listItem: [],
    valueSearch: "",
    deletePopupOpen: false,
    itemsToDelete: [],
    deletionStartMonths: {},
    options: {
      customerSegmentation: [],
      starsCustomer: [],
      rangeFacing: [],
      storeId: [],
      codiceStoreSap: [],
      publishDate: [],
      status: [],
      classification: []
    },
    valuesFilters: {
      customerSegmentation: null,
      starsCustomer: null,
      rangeFacing: null,
      storeId: null,
      codiceStoreSap: null,
      publishDate: null,
      status: null,
      classification: null
    },
    isClusterClicked: false,
  };

  componentDidMount = () => {
    if (this.props.listItem) {
      this.setState({
        listItem: [...this.props.listItem],
      });
    }
    this.props.getClusterFiltersOptions(this.props.selectedFilters);
  };

  componentDidUpdate = (prevProps) => {

    if (prevProps.clientClassificationPopupVisible !== this.props.clientClassificationPopupVisible) {
      if (!this.props.clientClassificationPopupVisible) {
        this.props.getClusterFiltersOptions(this.props.selectedFilters);
      }
    }
    if (prevProps.listItem !== this.props.listItem)
      this.setState({
        listItem: [...this.props.listItem],
      });

    if (prevProps.options !== this.props.options) {
      this.setState({
        options: _.cloneDeep(this.props.options),
      });
    }

    if (
      this.state.isClusterClicked
    ) {
      this.props.history.push("/cluster");
      this.setState({
        isClusterClicked: false,
      });
    }
  };

  selectClusters = (singleItem) => {
    let selectedClusters = [...this.state.selectedClusters]
    const clusterLabels = selectedClusters.map(cluster => cluster.clusterLabel)

    if (clusterLabels.includes(singleItem.clusterLabel)) {
      selectedClusters = selectedClusters.filter(cluster => cluster.clusterLabel !== singleItem.clusterLabel)
    }
    else if(!clusterLabels.includes(singleItem.clusterLabel)) {
      selectedClusters.push(singleItem)
    }
    this.setState({
      selectedClusters: selectedClusters
    });
    console.log(singleItem);
  }

  checkIfSelected = (singleItem) => {
    return this.state.selectedClusters.map(cluster => cluster.clusterLabel).includes(singleItem.clusterLabel)
  }

  // Inside ListCluster class

  goToCluster = () => {
    let clustersToOpen = [...this.state.selectedClusters];

    if (clustersToOpen.length > OPENED_CLUSTER_LIMIT) {
      clustersToOpen = clustersToOpen.slice(0, OPENED_CLUSTER_LIMIT);
      console.warn(`Opening the first ${OPENED_CLUSTER_LIMIT} of ${this.state.selectedClusters.length} selected clusters due to the opening limit.`);
    }

    const viewer = clustersToOpen.map(singleItem => {
      return !!(singleItem.userLock && (this.props.user.user_name !== singleItem.userLock));
    }).reduce((a, b) => a || b, false);

    if (clustersToOpen.length > 0) {
      this.props.getClusterWithLock(clustersToOpen, () => { }, viewer);
      this.setState({
        isClusterClicked: true,
      });
    } else {
      console.warn("No clusters selected to open.");
    }
  };


  selectAll = () => {
    let selectedClusters = [...this.state.listItem]
    this.setState({
      selectedClusters
    })
  }

  deselectAll = () => {
    let selectedClusters = []
    this.setState({
      selectedClusters
    })
  }

  togglePopup = () =>
    this.setState((prevState) => {
      return { isAddClusterOpen: !prevState.isAddClusterOpen };
    });

  handleSearch = (e) => {
    let valueObj = handleSearchResults(e, this.props.listItem, "cluster");

    this.setState({
      listItem: valueObj.listItem,
      valueSearch: valueObj.valueSearch,
    });
  };

  handleChangeOptions = (valueArray, type) => {
    let valueSearch = this.state.valueSearch,
      valuesFilters = { ...this.state.valuesFilters },
      filtersObj,
      listObj;

    // check search results
    let { listItem } = handleSearchResults(
      valueSearch,
      this.props.listItem,
      "cluster"
    );
    // filter results
    filtersObj = filterResults(listItem, valuesFilters, valueArray, type, true);
    //check publish date
    if (valuesFilters.publishDate)
      listObj = handleSearchResults(
        valuesFilters.publishDate,
        filtersObj.filteredResults,
        "date"
      );

    this.setState({
      listItem: listObj ? listObj.listItem : filtersObj.filteredResults,
      valuesFilters: filtersObj.selectedFilters,
    });
  };

  onChangeDatePicker = (publishDate) => {
    let valuesFilters = { ...this.state.valuesFilters },
      filtersObj,
      listObj;

    if (publishDate === null) {
      let valueSearch = this.state.valueSearch;
      let { listItem } = handleSearchResults(
        valueSearch,
        this.props.listItem,
        "cluster"
      );
      filtersObj = filterResults(
        listItem,
        valuesFilters,
        [],
        "publishDate",
        true
      );
      //check date
      listObj = handleSearchResults(
        publishDate,
        filtersObj.filteredResults,
        "dateRange"
      );
    } else {
      listObj = handleSearchResults(
        publishDate,
        this.state.listItem,
        "dateRange"
      );
    }

    this.setState({
      listItem: listObj.listItem,
      valuesFilters: {
        ...valuesFilters,
        publishDate,
      },
    });
  };

  redirect = () => this.props.history.push("/cluster");

  openDeletePopup = (items) => {
    const deletableItems = items.filter(cluster => {
      if (!this.props.auth?.grants) return false;
      return canDelete(
          this.props.auth.grants,
          cluster.brandCode,
          cluster.starZones
      );
    });

    deletableItems.forEach(cluster => {
      this.props.getClusterMonths(cluster.clusterId);
    });

    this.setState({
      itemsToDelete: deletableItems,
      deletionStartMonths: {}, // Initialize as empty, user will select from fetched data
      deletePopupOpen: true,
    });
  };


  closeDeletePopup = () => {
    this.setState({
      itemsToDelete: [],
      deletionStartMonths: {}, // <-- Reset this
      deletePopupOpen: false,
    });
  };

  handleDeletionMonthChange = (clusterId, selectedMonthId) => {
    this.setState(prevState => ({
      deletionStartMonths: {
        ...prevState.deletionStartMonths,
        [clusterId]: selectedMonthId
      }
    }));
  };
  handleConfirmDelete = () => {
    const { itemsToDelete, deletionStartMonths } = this.state;

    const deletionRequests = itemsToDelete
        .map(cluster => ({
          clusterId: cluster.clusterId,
          monthIdFrom: deletionStartMonths[cluster.clusterId]
        }))
        .filter(req => req.monthIdFrom && req.monthIdFrom !== '');

    if (deletionRequests.length === 0) {
      console.warn("No valid deletion requests to process (ensure months are selected).");
      this.closeDeletePopup();
      return;
    }

    console.log(`Dispatching bulk delete for ${deletionRequests.length} clusters:`, deletionRequests);

    this.props.deleteClusters(deletionRequests, this.props.selectedFilters);

    this.setState(prevState => ({
      selectedClusters: prevState.selectedClusters.filter(sc =>
          !deletionRequests.some(req => req.clusterId === sc.clusterId)
      ),
    }));

    this.closeDeletePopup();
  };

  applyHomepageMonthToAllDeletions = () => {
    const homepageMonthFilter = this.props.selectedFilters?.months;
    console.log(this.props.selectedFilters)
    const homepageMonthValue = homepageMonthFilter?.value;
    console.log(homepageMonthFilter)
    if (!homepageMonthValue || !this.state.itemsToDelete.length) {
      return;
    }

    const newDeletionStartMonths = { ...this.state.deletionStartMonths };
    let changesMade = false;

    this.state.itemsToDelete.forEach(cluster => {
      const fetchedMonths = this.props.monthsByClusterId[cluster.clusterId];
      if (fetchedMonths && fetchedMonths.includes(homepageMonthValue)) {
        newDeletionStartMonths[cluster.clusterId] = homepageMonthValue;
        changesMade = true;
      } else {
        console.warn(`Homepage month ${homepageMonthValue} is not an available deletion start month for cluster ${cluster.clusterLabel}.`);
      }
    });

    if (changesMade) {
      this.setState({ deletionStartMonths: newDeletionStartMonths });
    }
  };

  render() {
/*    const {
      listItem: stateListItem, // Rename local state list
      selectedClusters,
      valueSearch,
      //options,
      //valuesFilters,
      isAddClusterOpen,
      deletePopupOpen, // <-- Get from state
      itemsToDelete    // <-- Get from state
    } = this.state;

    const currentListSource = stateListItem;*/

    const notDeletedItems = this.state.listItem.filter(
      (cluster) => cluster.status !== "DELETED"
    );
    const listItem = notDeletedItems.map((singleItem) => {
      let isSelected = this.checkIfSelected(singleItem);
      let badgeText = null;
      let badgeClassName = ';'
      if(singleItem.legoMonth){
        badgeText = "FAKE MONTH";
        badgeClassName = "lego";
      }
      return(
        <ListItemHome
          item={singleItem}
          type="cluster"
          key={singleItem.clusterId}
          handleClick={() => this.selectClusters(singleItem)}
          iconClass="icon-arrow2"
          iconClassTrash="icon-cestino"
          iconClassWarning="icon-triangle-black"
          deleteItem={() => this.openDeletePopup([singleItem])}
          listItemClass={isSelected ? "selected" : ""}
          badgeText={badgeText}
          badgeClassName={badgeClassName}
        >
          {singleItem.clusterLabel}
        </ListItemHome>
      )})

    let options = this.state.options;
    let valuesFilters = this.state.valuesFilters;

    return (
      <React.Fragment>
        <div className="list-component col-4 module">
          <div className="list-content component">
            <div className="list-container-element">
              <header>
                <h3>Cluster Selection</h3>
                <CustomSearch
                  placeholder="Cluster Label"
                  handleChange={this.handleSearch}
                  value={this.state.valueSearch}
                />
              </header>
              <div className="filter-list">
                <div className="row no-gutters">
                  <div className="col-6">
                    <CustomSelect
                      placeholder="Client Name"
                      options={options.starsCustomer}
                      isMulti
                      handleChange={(e) =>
                        this.handleChangeOptions(e, "starsCustomer")
                      }
                      value={valuesFilters.starsCustomer}
                    />
                    <CustomSelect
                      placeholder="SAP Number"
                      options={options.codiceStoreSap}
                      isMulti
                      handleChange={(e) =>
                        this.handleChangeOptions(e, "codiceStoreSap")
                      }
                      value={valuesFilters.codiceStoreSap}
                    />
                    <CustomSelect
                      placeholder="Store id"
                      options={options.storeId}
                      isMulti
                      handleChange={(e) => this.handleChangeOptions(e, "storeId")}
                      value={valuesFilters.storeId}
                    />
                    <CustomSelect
                      placeholder="Status"
                      options={options.status}
                      handleChange={(e) => this.handleChangeOptions(e, "status")}
                      value={valuesFilters.status}
                      isMulti
                    />
                  </div>
                  <div className="col-6">
                    <CustomSelect
                      placeholder="Range Facing"
                      options={options.rangeFacing}
                      handleChange={(e) =>
                        this.handleChangeOptions(e, "rangeFacing")
                      }
                      isMulti
                      value={valuesFilters.rangeFacing}
                    />
                    <CustomSelect
                      placeholder="Segmentation"
                      options={options.customerSegmentation}
                      isMulti
                      handleChange={(e) =>
                        this.handleChangeOptions(e, "customerSegmentation")
                      }
                      value={valuesFilters.customerSegmentation}
                    />
                    <CustomSelect
                      placeholder="Client Classification"
                      options={options.classification}
                      isMulti
                      handleChange={(e) =>
                        this.handleChangeOptions(e, "classification")
                      }
                      value={valuesFilters.classification}
                    />
                    <DateRangePicker
                      onChange={this.onChangeDatePicker}
                      value={this.state.valuesFilters.publishDate}
                      format="dd/MM/y"
                      calendarIcon={null}
                    />
                  </div>
                </div>
              </div>
              <div className="main-content">
                {
                this.state.selectedClusters.length > 0 && 
                  <p style={{
                    textAlign: "left",
                    paddingLeft: "24px",
                    color: this.state.selectedClusters.length === OPENED_CLUSTER_LIMIT ? "red" : "black"
                  }}>
                    You selected {this.state.selectedClusters.length} out of {this.state.listItem?.length} clusters
                  </p>
                }
                <ul className="list">
                  <ListItem
                    handleClick={() => this.togglePopup("isAddClusterOpen")}
                    isDisabled={
                      this.props.auth &&
                      this.props.auth.grants &&
                      !canCreate(
                        this.props.auth.grants,
                        !!this.props.selectedFilters.brand.length &&
                        this.props.selectedFilters.brand
                      )
                    }
                    listItemClass={
                      "list-item-black" + (this.props.isEditable ? "" : " close")
                    }
                    iconClass="icon-plus"
                  >
                    Create New Cluster
                  </ListItem>
                  {listItem}
                </ul>
              </div>
              <div className="module-footer">
                <div className="outer-box-btn">
                  <div className="btn-box">
                    <Button
                        btnClass="btn-medium"
                        disabled={this.state.selectedClusters.length === 0}
                        handleClick={this.goToCluster}
                    >
                      Open Select (max {OPENED_CLUSTER_LIMIT})
                    </Button>
                    <Button
                        btnClass="btn-medium"
                        handleClick={this.selectAll}
                    >
                      Select All
                    </Button>
                  </div>
                  <div className="btn-box">
                    <Button
                        btnClass="btn-medium"
                        disabled={this.state.selectedClusters.length === 0}
                        handleClick={this.deselectAll}
                    >
                      Deselect All
                    </Button>
                    <Button
                        btnClass="btn-medium"
                        disabled={
                            !this.state.selectedClusters.length ||
                            !this.state.selectedClusters.every(cluster =>
                                    this.props.auth?.grants && canDelete(
                                        this.props.auth.grants,
                                        cluster.brandCode,
                                        cluster.starZones
                                    )
                            )
                        }
                        handleClick={() => this.openDeletePopup(this.state.selectedClusters)}
                    >
                      Delete All
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.isAddClusterOpen && (
          <AddClusterPopup
            togglePopup={() => this.togglePopup("isAddClusterOpen")}
            redirect={this.redirect}
            macroList={this.props.allMacroList}
          />
        )}
        {this.state.deletePopupOpen && (
            <Popup
                popupClass="popup-medium popup-delete-module-months"
                title="Confirm Cluster Deletion"
                isDoubleButton
                btnName="Confirm"
                btnName2="Cancel"
                close={this.closeDeletePopup}
                disabled={
                    !this.state.itemsToDelete.length ||
                    this.state.itemsToDelete.some(c => !this.state.deletionStartMonths[c.clusterId])
                }
                handleClick={this.handleConfirmDelete}
            >
              <div style={{marginBottom: '1rem', display: 'flex', justifyContent: 'flex-end'}}>
                <Button
                    btnClass="btn-small btn-info"
                    handleClick={this.applyHomepageMonthToAllDeletions}
                >
                  SELECT THE SEARCHED MONTH
                </Button>
              </div>
              <div className="box-delete-items-with-months">
                {this.state.itemsToDelete.length ? (
                    this.state.itemsToDelete.map((singleItem) => {
                      const fetchedMonths = this.props.monthsByClusterId[singleItem.clusterId];
                      const isLoadingMonths = !fetchedMonths;

                      const monthOptions = fetchedMonths
                          ? fetchedMonths
                              .map(m => ({ value: m, label: m}))
                              .filter(opt => opt.value)
                              .sort((a, b) => sortMonthIds(a.value, b.value))
                          : [];
                      const currentSelectionValue = this.state.deletionStartMonths[singleItem.clusterId] || '';
                      const selectedOptionObject = monthOptions.find(opt => opt.value === currentSelectionValue) || null;

                      return (
                          <div key={singleItem.clusterId} className="delete-item-row">
                            <span className="delete-item-label">{singleItem.clusterLabel}</span>
                            <CustomSelect
                                selectClass="delete-item-month-select"
                                placeholder={isLoadingMonths ? "Loading..." : "-- Select Month --"}
                                options={monthOptions}
                                value={selectedOptionObject}
                                handleChange={(selectedOption) => {
                                  const selectedMonthId = selectedOption ? selectedOption.value : '';
                                  this.handleDeletionMonthChange(singleItem.clusterId, selectedMonthId);
                                }}
                                isDisabled={isLoadingMonths ||!monthOptions.length}
                                isMulti={false}
                                isSearchable={false}
                            />
                          </div>
                      );
                    })
                ) : (
                    <p>You don't have authorization to delete the selected cluster(s).</p>
                )}
              </div>
            </Popup>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFilters: state.filter.selectedFilters,
    options: state.filter.filtersOptionsCluster,
    lockCluster: state.user.lockCluster,
    isLockClusterLoading: state.user.isLockClusterLoading,
    user: state.authentication.user,
    auth: state.authentication,
    allMacroList: state.filter.allMacroList,
    monthsByClusterId: state.cluster.monthsByClusterId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setNewCluster: (filters, cluster) =>
        dispatch(actions.setNewCluster(filters, cluster)),
    getClusterFiltersOptions: (selectedFilters) =>
        dispatch(actions.getClusterFiltersOptions(selectedFilters)),
    getStoreIdFiltered: (selectedFilters, stars) =>
        dispatch(actions.getStoreIdFiltered(selectedFilters, stars)),
    getClusterWithLock: (cluster, callBack, viewer) =>
        dispatch(actions.getClusterWithLock(cluster, callBack, viewer)),
    deleteClusters: (payload, filters) =>
        dispatch(actions.deleteClusterFromMonth(payload, filters)),
    getClusterMonths: (clusterId) =>
      dispatch(actions.getClusterMonths(clusterId))

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ListCluster);
